<template>
    <div class="">

        <div class="card">
            <div class="card-body">

                <h4 
                    class="card-title"
                    :class="($i18n.locale == 'ar') ? 'hacen_algeria' : 'txt-left'">
                    {{ label }}
                </h4>

                <div class="tab-danger pt-3">

                    <!-- Nav Tabs -->
                    <ul v-if="$i18n.locale == 'ar'" class="nav nav-tabs" role="tablist">
                        <li class="nav-item">
                            <a href="#tab-arabic" class="nav-link" role="tab" data-toggle="tab" aria-selected="true"
                                :class="($i18n.locale == 'ar') ? 'hacen_algeria font-size-15 active show' : ''">
                                {{ $t('app.arabic') }}
                            </a>
                        </li>
                        <li class="nav-item">
                            <a href="#tab-english" class="nav-link" role="tab" data-toggle="tab" aria-selected="false"
                                :class="($i18n.locale == 'ar') ? 'hacen_algeria font-size-15' : 'active show'">
                                {{ $t('app.english') }}
                            </a>
                        </li>
                    </ul>
                    <ul v-if="$i18n.locale == 'en'" class="nav nav-tabs" role="tablist">
                        <li class="nav-item">
                            <a href="#tab-english" class="nav-link" role="tab" data-toggle="tab" aria-selected="false"
                                :class="($i18n.locale == 'ar') ? 'hacen_algeria font-size-15' : 'active show'">
                                {{ $t('app.english') }}
                            </a>
                        </li>
                        <li class="nav-item">
                            <a href="#tab-arabic" class="nav-link" role="tab" data-toggle="tab" aria-selected="true"
                                :class="($i18n.locale == 'ar') ? 'hacen_algeria font-size-15 active show' : ''">
                                {{ $t('app.arabic') }}
                            </a>
                        </li>
                    </ul>
                    <!-- End Nav Tabs -->


                    <!-- Tab Panels -->
                    <div class="tab-content">
                        <div 
                            role="tabpanel" 
                            class="tab-pane fade pt-3"
                            :class="($i18n.locale == 'ar') ? 'active show' : ''" 
                            id="tab-arabic">

                            <!-- Title -->
                            <div v-if="hasTitle" class="form-group col-12">
                                <label 
                                    for="inputAR1" 
                                    class="col-form-label"
                                    :class="($i18n.locale == 'ar') ? 'hacen_algeria font-size-15' : 'float-left'">
                                    {{ labelTitle }}
                                </label>
                                <input 
                                    id="inputAR1"
                                    type="text" 
                                    class="form-control"
                                    :class="($i18n.locale == 'ar') ? 'hacen_algeria font-size-15' : ''"
                                    v-model="row.title_ar" 
                                    v-on:input="onFormChange">
                            </div>
                            <!-- End Title -->

                            <!-- Type -->
                            <div v-if="hasType" class="form-group col-12">
                                <label 
                                    for="inputARTY1" 
                                    class="col-form-label"
                                    :class="($i18n.locale == 'ar') ? 'hacen_algeria font-size-15' : 'float-left'">
                                    {{ labelType }}
                                </label>
                                <input 
                                    id="inputARTY1"
                                    type="text" 
                                    class="form-control"
                                    :class="($i18n.locale == 'ar') ? 'hacen_algeria font-size-15' : ''"
                                    v-model="row.type_ar" 
                                    v-on:input="onFormChange">
                            </div>
                            <!-- End Type -->

                            <!-- Model -->
                            <div v-if="hasModel" class="form-group col-12">
                                <label 
                                    for="inputARMO1" 
                                    class="col-form-label"
                                    :class="($i18n.locale == 'ar') ? 'hacen_algeria font-size-15' : 'float-left'">
                                    {{ labelModel }}
                                </label>
                                <input 
                                    id="inputARMO1"
                                    type="text" 
                                    class="form-control"
                                    :class="($i18n.locale == 'ar') ? 'hacen_algeria font-size-15' : ''"
                                    v-model="row.model_ar" 
                                    v-on:input="onFormChange">
                            </div>
                            <!-- End Type -->

                            <!-- Amount In letters -->
                            <div v-if="hasAmount" class="form-group col-12">
                                <label 
                                    for="inputAMO1" 
                                    class="col-form-label"
                                    :class="($i18n.locale == 'ar') ? 'hacen_algeria font-size-15' : 'float-left'">
                                    {{ labelAmount }}
                                </label>
                                <input 
                                    id="inputAMO1"
                                    type="text" 
                                    class="form-control"
                                    :class="($i18n.locale == 'ar') ? 'hacen_algeria font-size-15' : ''"
                                    v-model="row.amount_duo_in_letters_ar" 
                                    v-on:input="onFormChange">
                            </div>
                            <!-- End End in letters -->

                            <!-- Body -->
                            <div v-if="hasBody" class="form-group col-12">
                                <label 
                                    for="editorAR1" 
                                    class="col-form-label"
                                    :class="($i18n.locale == 'ar') ? 'hacen_algeria font-size-15' : 'float-left'">
                                    {{ labelBody }} 
                                </label>
                                <div v-if="$i18n.locale == 'en'" class="col-12"><br/><br/></div>
                                <editor id="editorAR1"
                                    v-model="row.body_ar"
                                    v-on:input="onFormChange"
                                    :api-key="editor.api_key"
                                    :init="{
                                        height: 300,
                                        menubar: editor.menubar,
                                        plugins: editor.plugins,
                                        toolbar: editor.toolbar
                                    }"
                                />
                            </div>
                            <!-- End Body -->

                            <!-- Address -->
                            <div v-if="hasAddress" class="form-group col-12">
                                <label 
                                    for="inputAR1" 
                                    class="col-form-label"
                                    :class="($i18n.locale == 'ar') ? 'hacen_algeria font-size-15' : 'float-left'">
                                    {{ labelAddress }}
                                </label>
                                <input 
                                    id="inputAR1"
                                    type="text" 
                                    class="form-control"
                                    :class="($i18n.locale == 'ar') ? 'hacen_algeria font-size-15' : ''"
                                    v-model="row.address_ar" 
                                    v-on:input="onFormChange">
                            </div>
                            <!-- End Address -->

                            <!-- ContactPerson -->
                            <div v-if="hasContactPerson" class="form-group col-12">
                                <label 
                                    for="inputAR1" 
                                    class="col-form-label"
                                    :class="($i18n.locale == 'ar') ? 'hacen_algeria font-size-15' : 'float-left'">
                                    {{ labelContactPerson }}
                                </label>
                                <input 
                                    id="inputAR1"
                                    type="text" 
                                    class="form-control"
                                    :class="($i18n.locale == 'ar') ? 'hacen_algeria font-size-15' : ''"
                                    v-model="row.contact_person_ar" 
                                    v-on:input="onFormChange">
                            </div>
                            <!-- End ContactPerson -->

                        </div>

                        <div 
                            role="tabpanel" 
                            class="tab-pane fade in pt-3" 
                            :class="($i18n.locale == 'ar') ? '' : 'active show'" 
                            id="tab-english">

                            <!-- Title -->
                            <div v-if="hasTitle" class="form-group col-12">
                                <label 
                                    for="inputEN1" 
                                    class="col-form-label"
                                    :class="($i18n.locale == 'ar') ? 'hacen_algeria font-size-15' : 'float-left'">
                                    {{ labelTitle }} 
                                </label>
                                <input 
                                    id="inputEN1"
                                    type="text" 
                                    class="form-control"
                                    style="direction: ltr"
                                    :class="($i18n.locale == 'ar') ? 'hacen_algeria font-size-15' : ''"
                                    v-model="row.title_en" 
                                    v-on:input="onFormChange">
                            </div>
                            <!-- End Title -->


                            <!-- Type -->
                            <div v-if="hasType" class="form-group col-12">
                                <label 
                                    for="inputENTY1" 
                                    class="col-form-label"
                                    :class="($i18n.locale == 'ar') ? 'hacen_algeria font-size-15' : 'float-left'">
                                    {{ labelType }} 
                                </label>
                                <input 
                                    id="inputENTY1"
                                    type="text" 
                                    class="form-control"
                                    style="direction: ltr"
                                    :class="($i18n.locale == 'ar') ? 'hacen_algeria font-size-15' : ''"
                                    v-model="row.type_en" 
                                    v-on:input="onFormChange">
                            </div>
                            <!-- End Type -->

                            <!-- Model -->
                            <div v-if="hasModel" class="form-group col-12">
                                <label 
                                    for="inputENMO1" 
                                    class="col-form-label"
                                    :class="($i18n.locale == 'ar') ? 'hacen_algeria font-size-15' : 'float-left'">
                                    {{ labelModel }} 
                                </label>
                                <input 
                                    id="inputENMO1"
                                    type="text" 
                                    class="form-control"
                                    style="direction: ltr"
                                    :class="($i18n.locale == 'ar') ? 'hacen_algeria font-size-15' : ''"
                                    v-model="row.model_en" 
                                    v-on:input="onFormChange">
                            </div>
                            <!-- End Model -->

                            <!-- Amount in letters -->
                            <div v-if="hasAmount" class="form-group col-12">
                                <label 
                                    for="inputENAM1" 
                                    class="col-form-label"
                                    :class="($i18n.locale == 'ar') ? 'hacen_algeria font-size-15' : 'float-left'">
                                    {{ labelAmount }} 
                                </label>
                                <input 
                                    id="inputENAM1"
                                    type="text" 
                                    class="form-control"
                                    style="direction: ltr"
                                    :class="($i18n.locale == 'ar') ? 'hacen_algeria font-size-15' : ''"
                                    v-model="row.amount_duo_in_letters_en" 
                                    v-on:input="onFormChange">
                            </div>
                            <!-- End Amount in letters -->

                            <!-- Body -->
                            <div v-if="hasBody" class="form-group col-12">
                                <label 
                                    for="editorEN1" 
                                    class="col-form-label"
                                    :class="($i18n.locale == 'ar') ? 'hacen_algeria font-size-15' : 'float-left'">
                                    {{ labelBody }} 
                                </label>
                                <div v-if="$i18n.locale == 'en'" class="col-12"><br/><br/></div>
                                <editor id="editorEN1"
                                    v-model="row.body_en"
                                    v-on:input="onFormChange"
                                    :api-key="editor.api_key"
                                    :init="{
                                        height: 300,
                                        menubar: editor.menubar,
                                        plugins: editor.plugins,
                                        toolbar: editor.toolbar
                                    }"
                                />
                            </div>
                            <!-- End Body -->


                            <!-- Address -->
                            <div v-if="hasAddress" class="form-group col-12">
                                <label 
                                    for="inputEN1" 
                                    class="col-form-label"
                                    :class="($i18n.locale == 'ar') ? 'hacen_algeria font-size-15' : 'float-left'">
                                    {{ labelAddress }} 
                                </label>
                                <input 
                                    id="inputEN1"
                                    type="text"
                                    class="form-control"
                                    style="direction: ltr"
                                    :class="($i18n.locale == 'ar') ? 'hacen_algeria font-size-15' : ''"
                                    v-model="row.address_en" 
                                    v-on:input="onFormChange">
                            </div>
                            <!-- End Address -->

                             <!-- ContactPerson -->
                            <div v-if="hasContactPerson" class="form-group col-12">
                                <label 
                                    for="inputEN1" 
                                    class="col-form-label"
                                    :class="($i18n.locale == 'ar') ? 'hacen_algeria font-size-15' : 'float-left'">
                                    {{ labelContactPerson }} 
                                </label>
                                <input 
                                    id="inputEN1"
                                    type="text" 
                                    class="form-control"
                                    style="direction: ltr"
                                    :class="($i18n.locale == 'ar') ? 'hacen_algeria font-size-15' : ''"
                                    v-model="row.contact_person_en" 
                                    v-on:input="onFormChange">
                            </div>
                            <!-- End Address -->

                        </div>
                    </div>
                    <!-- End Tab Panels -->

                </div>
            </div>
        </div>
         
    </div>
</template>

<script>
import Editor from '@tinymce/tinymce-vue';

export default {
    namme: 'FormElements',
    components: {
        Editor
    },
    props: [
        'label',
        'labelTitle',
        'labelType',
        'labelModel',
        'labelAmount',
        'labelBody',
        'labelAddress',
        'labelContactPerson',

        'hasTitle',
        'hasType',
        'hasModel',
        'hasAmount',
        'hasBody',
        'hasAddress',
        'hasContactPerson',

        'title_ar',
        'title_en',

        'body_ar',
        'body_en',

        'type_ar',
        'type_en',

        'model_ar',
        'model_en',

        'amount_duo_in_letters_ar',
        'amount_duo_in_letters_en',

        'address_ar',
        'address_en',

        'contact_person_ar',
        'contact_person_en',

    ],
    data() {
        return {
            row: {
                title_ar : this.$props.title_ar,
                title_en : this.$props.title_en,

                body_ar : this.$props.body_ar,
                body_en : this.$props.body_en,

                type_ar : this.$props.type_ar,
                type_en : this.$props.type_en,

                model_ar : this.$props.model_ar,
                model_en : this.$props.model_en,

                amount_duo_in_letters_ar : this.$props.amount_duo_in_letters_ar,
                amount_duo_in_letters_en : this.$props.amount_duo_in_letters_en,

                address_ar : this.$props.address_ar,
                address_en : this.$props.address_en,

                contact_person_ar : this.$props.contact_person_ar,
                contact_person_en : this.$props.contact_person_en,
            },

            editor: {
                api_key: window.editor_apiKey,
                menubar: window.editor_menubar,
                plugins: window.editor_plugins,
                toolbar: window.editor_toolbar,
            },
        }
    },
    watch: {
      'row.title_ar': function (value){
        this.row.title_en = value;
      },
      'row.body_ar':function (value){
        this.row.body_en = value;
      },
      'row.type_ar':function (value){
        this.row.type_en = value;
      },
      'row.model_ar':function (value){
        this.row.model_en = value;
      },
      'row.amount_duo_in_letters_ar':function (value){
        this.row.amount_duo_in_letters_en = value;
      },
      'row.address_ar':function (value){
        this.row.address_en = value;
      },
      'row.contact_person_ar':function (value){
        this.row.contact_person_en = value;
      },
    },
    methods: {
        onFormChange(){
            const data = {
                title_ar: this.row.title_ar,
                title_en: this.row.title_en,

                body_ar: this.row.body_ar,
                body_en: this.row.body_en,

                type_ar: this.row.type_ar,
                type_en: this.row.type_en,

                model_ar: this.row.model_ar,
                model_en: this.row.model_en,

                amount_duo_in_letters_ar: this.row.amount_duo_in_letters_ar,
                amount_duo_in_letters_en: this.row.amount_duo_in_letters_en,

                address_ar: this.row.address_ar,
                address_en: this.row.address_en,

                contact_person_ar: this.row.contact_person_ar,
                contact_person_en: this.row.contact_person_en,
            }
            this.$emit('formChange', data)
        },
    }
}
</script>
